import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useJsApiLoader, GoogleMap } from '@react-google-maps/api'
import { ICompany } from '@verzekeringapp-mono/shared/src/api/types/company'
import { useAppSelector } from '@verzekeringapp-mono/shared/src/hooks/state'
import { getRepairersSelector } from '@verzekeringapp-mono/shared/src/state/selectors/companies'
import React from 'react'
import LocationCardModal from './LocationCardModal'
import LocationMarker from './LocationMarker'

interface IMapViewProps {
  setIsFilterModalOpen: (isOpen: boolean) => void
  setMapRef: (map: google.maps.Map) => void
  center: google.maps.LatLngLiteral
  onCenterChanged: (center: google.maps.LatLngLiteral) => void
}

const MapView = ({ setIsFilterModalOpen, setMapRef, center, onCenterChanged }: IMapViewProps) => {
  const [isModalOpen, setIsModalOpen] = React.useState(false)
  const [selectedLocation, setSelectedLocation] =
    React.useState<ICompany | null>(null)

  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY ?? ''
  })

  const locations = useAppSelector(getRepairersSelector)

  return (
    <div className='w-full h-5/6 relative'>
      <div className='absolute top-4 left-4 z-10 rounded-md border border-border-subtle bg-surface-card p-4 text-text-primary'>
        {locations.length} resultaten
      </div>

      <button
        type='button'
        onClick={() => setIsFilterModalOpen(true)}
        className='absolute top-4 right-4 z-10 rounded-md border border-action-primary-border bg-action-primary-background p-4 text-action-primary-foreground'
      >
        <FontAwesomeIcon
          icon='sliders'
          className='mr-2 text-icon-on-brand'
        />
        Filter
      </button>

      {isLoaded
        ? (
          <GoogleMap
            id='google-map-damage-repair-screen'
            mapContainerClassName='w-full h-full'
            onLoad={map => setMapRef(map)}
            options={{
              fullscreenControl: false,
              mapTypeControl: false,
              streetViewControl: false
            }}
            center={center}
            zoom={9}
          >
            <>
              {locations.map(location => (
                <LocationMarker
                  openModal={location => {
                    setIsModalOpen(true)
                    setSelectedLocation(location)
                    onCenterChanged({
                      lat: parseFloat(location.latitude),
                      lng: parseFloat(location.longitude)
                    })
                  }}
                  key={location.id}
                  location={location}
                />
              ))}

              {isModalOpen && !!selectedLocation && (
                <LocationCardModal
                  onClose={() => {
                    setIsModalOpen(false)
                    setSelectedLocation(null)
                  }}
                  location={selectedLocation}
                />
              )}
            </>
          </GoogleMap>
        )
        : (
          <p>Loading...</p>
        )}
    </div>
  )
}

export default MapView
